// extracted by mini-css-extract-plugin
export default {"dialog":"styles_dialog__NXd+w","header":"styles_header__xzIP-","paper":"styles_paper__gnmh7","body":"styles_body__ntP7i"};